import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, RulerIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: '9 tomos premium'
}, {
  icon: GiftIcon,
  label: '5 bonos estratégicos'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage-deep contour plan-grid relative isolate overflow-hidden" data-id="element-103" data-mp="xb5rtfab8tw9">
      <div className="tick-bar h-3 w-full" aria-hidden="true" data-id="element-104" data-mp="s9q7xqjvctfg" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-105" data-mp="nczt16jsw3vm">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-yellow/40 bg-navy px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-yellow" data-id="element-106" data-mp="3d21tk0zn2qpb">
          <RulerIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="3o6u7fbahgtdg" /> Mega Pack Topografía Listo
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-id="element-108" data-mp="39cflp2zjb5v3">
          Todo tu año de Topografía<br data-id="element-109" data-mp="2qkmsp8kgtknd" />
          <span className="text-yellow" data-id="element-110" data-mp="2qkwmz8cjmdyv">resuelto en una tarde.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-111" data-mp="2vi50uwqnrvub">
          <img src={productImage} alt="Mega Pack Topografía Listo: nueve tomos y cinco bonos con instrumentos de medición topográfica" className="mx-auto w-full drop-shadow-[0_24px_44px_rgba(2,10,25,.6)]" data-id="element-112" data-mp="2lmv3wnf4aene" />
        </motion.div>

        <div className="mt-9" data-id="element-113" data-mp="icrnupbfmj8p">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-114" data-mp="i9vp4yrrfqj7">
            Quiero mi Mega Pack ahora
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-115" data-mp="1azuhp455y5sm">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-steel bg-navy/70 px-3 py-2" data-id="element-116" data-mp="112pur23hu6ar">
              <Icon className="h-3.5 w-3.5 text-yellow" aria-hidden="true" data-id="element-117" data-mp="x0uwy7krub1q" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-mutedDark" data-id="element-118" data-mp="3hrlkiif0q78z">
          Para docentes de Topografía de toda Latinoamérica · Actualizado 2026
        </p>
      </div>
    </section>;
}